var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinLightDisabled = function SvgPinLightDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 89,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 80,
    x: 8,
    y: 9,
    fill: "url(#pin_light_disabled_svg__a)",
    rx: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#pin_light_disabled_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 18,
    y: 1,
    fill: "url(#pin_light_disabled_svg__c)",
    rx: 8.5,
    transform: "rotate(90 18 1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_light_disabled_svg__a",
    x1: 9.5,
    x2: 2.055,
    y1: 89,
    y2: 88.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pin_light_disabled_svg__c",
    x1: 18,
    x2: 35,
    y1: 1,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6F9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pin_light_disabled_svg__b",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5539_96594",
    stdDeviation: 0.5
  })))));
};
export default SvgPinLightDisabled;